module.exports = __webpack_public_path__ + "static/media/line-big.a384cb98.svg";